import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=bdb0d97a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdb0d97a')) {
      api.createRecord('bdb0d97a', component.options)
    } else {
      api.reload('bdb0d97a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=bdb0d97a&", function () {
      api.rerender('bdb0d97a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-230n7phGQOPEg/JS/imageCarousel.vue"
export default component.exports